export const AI_EVENTS = {
  EMBED_VIEWED: 'UI - AI Chat - Embed viewed',
  SUGGESTION_CLICKED: 'UI - AI Chat - Suggestion clicked',
  COMPOSER_FOCUSED: 'UI - AI Chat - Composer focused',
  MESSAGE_SENT: 'UI - AI Chat - Message sent',
  CONVERSATION_STARTED: 'UI - AI Chat - Conversation started',
  FIRST_TOKEN_RECEIVED: 'UI - AI Chat - First token received',
  RESPONSE_COMPLETED: 'UI - AI Chat - Response completed',
  RESPONSE_ERROR: 'UI - AI Chat - Response error',
  QUOTA_EXCEEDED: 'UI - AI Chat - Quota exceeded',
  AGENT_PAGE_VIEWED: 'UI - AI Chat - Agent page viewed',
  HANDOFF_COMPLETED: 'UI - AI Chat - Handoff completed',
  PANEL_LINK_CLICKED: 'UI - AI Chat - Panel link clicked',
  MESSAGE_COPIED: 'UI - AI Chat - Message copied',
  CONVERSATION_SELECTED: 'UI - AI Chat - Conversation selected',
  CONVERSATION_RESET: 'UI - AI Chat - Conversation reset',
  FEEDBACK_SUBMITTED: 'UI - AI Chat - Feedback submitted',
} as const;

export type AiEventName = (typeof AI_EVENTS)[keyof typeof AI_EVENTS];

export type AiAnalyticsContext = {
  entryPoint: 'embed' | 'agent_page';
  embedContext?: string;
  isSuggestion?: boolean;
  suggestionKey?: string;
  entrySource?: string;
};

export type AiChatStreamAnalytics = {
  analyticsContext?: AiAnalyticsContext;
  userMessageId?: string;
  assistantMessageId?: string;
  question?: string;
  conversationTurn?: number;
  isFirstMessage?: boolean;
};
